<template>
  <div class="ModalTable">
    <RadioGroup v-model="disabledGroup" @on-change="checkButtonShow">
      <Radio :label="1">設定開獎號碼</Radio>
      <Radio :label="2" :disabled="radioDisable">設定本期RTP</Radio>
    </RadioGroup>
    <span class="red-text">注：封盘后才能计算与设定本期RTP</span>
    <table class="TB_COLLAPSE" width="100%">
      <thead v-if="disabledGroup === 1">
        <tr>
          <th v-for="it in columns" :key="it.title">{{it.title}}</th>
          <th>计算RTP</th>
        </tr>
      </thead>
      <tbody v-if="disabledGroup === 1">
        <tr :class="{'timerout': trColorStatus}">
          <td width="10%" v-for="(it, index) in columns" :key="it.title" class="pr-2 pl-2">
            <Select
              ref="Select"
              v-model="Select[index]"
              filterable
              @on-query-change="queryChange"
              @on-change="SelectColor[index] = false"
              :not-found-text="notFoundText"
              :disabled="timeLodingStatus === 2"
              :class="{'select-active': SelectColor[index]}"
            >
              <Option value="-">未指定</Option>
              <Option v-for="i in NumberSelect(Select[index])" :key="it.title+i" :value="i">{{i}}</Option>
            </Select>
          </td>
          <td width="10%">
            <Button type="info" @click="ClickComputeRTP" :disabled="RTPButtonDisable">计算RTP</Button>
          </td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <th colspan="2" v-for="it in theadBottom" :key="it.title">{{it.title}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            colspan="2"
            width="25%"
            style="height: 40px"
          >{{this.theadBottom.toval.value | commaFormat}}</td>
          <td
            colspan="2"
            width="25%"
            style="height: 40px"
            :class="{'active': tdColorState}"
          >{{this.theadBottom.win.value | commaFormat}}</td>
          <td
            colspan="2"
            width="25%"
            style="height: 40px"
          >{{ this.theadBottom.aimsrtp.value ? `${this.theadBottom.aimsrtp.value}%` : null }}</td>
          <td
            colspan="2"
            width="25%"
            style="height: 40px"
            :class="{'active': disabledGroup === 1 ? tdColorState : false}"
          >
            <div v-if="disabledGroup === 1">
              <span :class="{'red-text': rtpData > 100}">{{rtpData ? `${rtpData}%` : rtpData}}</span>
            </div>
            <div v-if="disabledGroup === 2">
              <Input
                ref="InputRTP"
                v-model="InputRTP"
                class="mr-1 input-rtp-value"
                placeholder="建议数值70~105"
                :class="{...exceeedValue, 'input-active': RTPvalueColor }"
                @on-focus="InputRTPFocus"
                @on-blur="InputRTPBlur"
                @on-change="RTPvalueAPIData = false"
              ></Input>
              <Button type="info" @click="ClickComputeNumber" :disabled="RTPvalueAPIData">计算号码</Button>
              <p class="red-text mt-2">* 系统只能排出相对接近您所设定RTP的号码组合</p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="TB_COLLAPSE" width="100%" v-if="disabledGroup === 2">
      <thead>
        <tr>
          <th v-for="it in columns" :key="it.title">{{it.title}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style="height: 40px"
            v-for="(it, index) in Select"
            :key="index"
            :class="{'active': SelectColor[index]}"
          >{{it != '-' ? it : ''}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import NP from 'number-precision'
import modalTableGame from '@/mixins/modal-table-game.js'
import ModalTableSixmark from '@/mixins/ModalTableSixmark'
import { mapGetters } from 'vuex'
import { ToDecimal } from 'utils'
// '本期押注', '本期派彩', '目标RTP', '本期RTP'
export default {
  name: 'ModalTableSixmarkDaily',
  extends: modalTableGame,
  mixins: [ModalTableSixmark],
  props: {
    gameid: Number,
    ButtonRandomNumberShow: Boolean
  },
  data () {
    return {
      SelectColor: [false, false, false, false, false, false, false],
      getSelect: ['', '', '', '', '', '', ''], // 计算rtp取得到的号码 
      disabledGroup: 1,
      theadBottom: {
        toval: {
          title: '本期押注',
          value: null
        },
        win: {
          title: '本期派彩',
          value: null
        },
        aimsrtp: {
          title: '目标RTP',
          value: null
        },
        rtp: {
          title: '本期RTP',
          value: null
        }
      },
      RTPvalue: '',
      RTPvalueColor: false,   // RTP input 顏色狀態
      RTPvalueAPIData: false, // 是否取得計算RTP值
      tdColorState: false,    // 是否點擊計算方法取的參數後替換顏色 
      item: {}
    }
  },
  computed: {
    ...mapGetters(['GetDailyCloseTimer']),
    RTPButtonDisable () { // 判断rtp 取得号码后需被锁定，当号码有变动后要取消锁定
      if (this.timeLodingStatus !== 1) return true
      if (this.GetDailyCloseTimer != '00:00:00') return true // 封盤時間後才可以進行rtp相關計算
      if (!this.getSelect.length) return false
      const result = this.getSelect.every((it, i) => this.getSelect[i] == this.Select[i])
      return result
    },
    radioDisable () {
      if (this.timeLodingStatus !== 1) return true
      if (this.GetDailyCloseTimer != '00:00:00') return true // 封盤時間後才可以進行rtp相關計算
    },
    InputRTP: {
      get () {
        return `${this.RTPvalue}`
      },
      set (val) {
        const value = val.replace(/[^\d.]/g, '')
        this.RTPvalue = value
        this.RTPInspectDecimalPointLenght(value)
      }
    },
    rtpData () {
      if (!this.theadBottom.rtp.value) return this.theadBottom.rtp.value
      return ToDecimal(NP.times(this.theadBottom.rtp.value, 100), 4)
    },
    exceeedValue () {
      return { 'exceeed-value': this.RTPvalue.replace(/[^\d.]/g, '') > 100 }
    }
  },
  watch: {
    showModal: {
      immediate: true,
      handler (val) {
        this.resetSelectColor()
        if (val) {
          this.theadBottom.aimsrtp.value = this.listPeriodData.RTP
          this.theadBottom.rtp.value = this.data.rtp
          this.GetGameToval()
        } else {
          this.resetRTP()
        }
      },
    },
    disabledGroup (val) {
      if (val === 1) {
        this.theadBottom.rtp.value = this.item.rtp
      } else {
        this.RTPvalue = this.theadBottom.rtp.value
          ? `${ToDecimal(NP.times(this.theadBottom.rtp.value, 100), 4)}%`
          : this.theadBottom.rtp.value != null ? '0%' : ''
        // this.RTPvalue = this.theadBottom.rtp.value ? `${NP.times(this.theadBottom.rtp.value, 100)}%` : ''
        this.RTPvalueColor = this.tdColorState
      }
    }
  },
  created () {
    this.checkButtonShow()
  },
  methods: {
    async GetGameToval () { // 取的本期押注資料
      try {
        const res = await this.$axios.gameLobby.GetGameToval({ gameid: this.gameid })
        this.theadBottom.toval.value = res.toval
        this.GetWinData()
      } catch (error) {
        console.log(error);
      }
    },
    GetWinData () { // 判斷是否取的計算rtp, 計算後的號碼，在次呼叫取得 本期派彩
      if (!this.data) return
      const number = this.data.mark.every(it => it != '-')
      const rtp = this.data.rtp
      if (number && rtp) {
        this.ClickComputeRTP(false)
      }
    },
    async ClickComputeRTP (first = true) { // 点击 计算RTP
      const postData = {
        gameid: this.gameid,
        mark: this.Select.toString()
      }
      try {
        const res = await this.$axios.gameLobby.SetEstimatedNumber(postData)
        const data = JSON.parse(res)
        if (data.status === 1) {
          this.item = data
          this.theadBottom.toval.value = data.toval
          this.theadBottom.win.value = ToDecimal(data.result)
          this.theadBottom.rtp.value = data.rtp
          this.getSelect = data.rebo
          this.tdColorState = first
          this.RTPvalueAPIData = true
          this.Select = data.rebo.map((it, i) => {
            if (it != this.Select[i]) this.SelectColor[i] = true
            return it + ""
          })
        }
      } catch (error) {
        console.log(error);
      }
    },
    async ClickComputeNumber () { // 点击 计算号码
      if (!this.RTPvalue) return this.$Message.error('請輸入RTP值');
      const _RTPvalue = this.RTPvalue.replace(/[^\d.]/g, '')
      if (_RTPvalue < 70 || _RTPvalue > 105) return this.$Message.error('RTP範圍 70%~105%');

      const postData = {
        gameid: this.gameid,
        rtp: Number(_RTPvalue)
      }
      try {
        const res = await this.$axios.gameLobby.SetEstimatedRTP(postData)
        this.item = res
        this.RTPvalue = `${NP.times(res.rtp, 100)}%`
        this.theadBottom.rtp.value = res.rtp
        this.theadBottom.win.value = ToDecimal(res.result)
        this.RTPvalueAPIData = true
        this.RTPvalueColor = true
        this.Select = res.mark.map((it, i) => {
          if (it != this.Select[i]) this.SelectColor[i] = true
          return it + ""
        })
        this.getSelect = this.Select
      } catch (error) {

      }
    },
    removeNumber () { // 重置号码
      this.Select = this.Select.map(it => it = '-')
      this.resetSelectColor()
      this.RTPvalueColor = false
      this.tdColorState = false
      this.theadBottom.rtp.value = null
      this.theadBottom.win.value = null
      this.item = {}
    },
    resetSelectColor () { // 重置下拉选单颜色
      this.SelectColor = this.SelectColor.map(it => it = false)
    },
    checkButtonShow () {
      this.$emit('update:ButtonRandomNumberShow', this.disabledGroup !== 2)
    },
    resetRTP () { // 重置清除RTP 相關狀態與參數
      this.theadBottom.toval.value = null
      this.theadBottom.win.value = null
      this.theadBottom.toval.value = null
      this.theadBottom.rtp.value = null
      this.RTPvalue = ''
      this.disabledGroup = 1
      this.RTPvalueColor = false
      this.RTPvalueAPIData = false
      this.tdColorState = false
      this.getSelect = this.getSelect.map(it => '')
      this.item = {}
    },
    InputRTPFocus () { // RTP 輸入匡聚焦，當有取得計算過得RTP時 就清除資料與顏色狀態; 否則直接帶入原本設定的值補上%符號
      if (this.RTPvalueAPIData) {
        this.RTPvalue = ''
        this.RTPvalueColor = false
      } else {
        this.RTPvalue = this.RTPvalue.replace(/[^\d.]/g, '')
      }
    },
    InputRTPBlur () {
      // RTP 輸入匡失焦，當無輸入值且有取得到計算的RTP參數，計算的RTP 倒入 Input且顏色開啟; 
      // 否則 Input 值導入 rtp.value、關閉顏色狀態、是否取得計算過RTP、補上%符號。
      if (this.RTPvalue == '' && this.theadBottom.rtp.value != null && this.RTPvalueAPIData) {
        const data = this.RTPvalueAPIData ? NP.times(this.theadBottom.rtp.value, 100) : this.theadBottom.rtp.value
        this.RTPvalue = `${ToDecimal(data, 4)}%`
        this.RTPvalueColor = true
      } else {
        this.theadBottom.rtp.value = NP.divide(this.RTPvalue, 100)
        this.RTPvalueColor = false
        this.RTPvalueAPIData = false
        this.RTPvalue = this.RTPvalue ? `${ToDecimal(this.RTPvalue, 4)}%` : ''
      }
    },
    RTPInspectDecimalPointLenght (value) { // 檢查RTP小數點是否超過四位了
      if (!value) return
      const array = value.split('.')
      if (array.length != 2) return
      const point = array[1]
      if (point.length > 4) {
        this.$Message.error({
          content: "小數點已超過4位",
          closable: true,
          duration: 5
        })
        return true
      }
    }
  }
}
</script>
<style lang="scss" >
$active-color: #fff598;
.select-active .ivu-select-selection,
.TB_COLLAPSE tbody td.active {
  background-color: $active-color;
}
.input-rtp-value {
  width: 200px;
  &.exceeed-value .ivu-input {
    color: #ff0000;
  }
  &.input-active .ivu-input {
    background-color: $active-color;
  }
  .ivu-input {
    text-align: center;
    & &::-webkit-input-placeholder {
      text-align: center;
    }

    &:-moz-placeholder {
      /* Firefox 18- */
      text-align: center;
    }

    &::-moz-placeholder {
      /* Firefox 19+ */
      text-align: center;
    }

    &:-ms-input-placeholder {
      text-align: center;
    }
  }
}
</style>